export default __webpack_public_path__ + "static/media/eligible-to-claim.baa91103.png";